export const POS_LOCK_EVENT = "billsarthi:pos-lock-changed";

const pinKey = (restaurantId) => `pos_lock_pin_hash_${restaurantId || "unknown"}`;
const lockedKey = (restaurantId) => `pos_app_locked_${restaurantId || "unknown"}`;

const digest = async (value) => {
  const bytes = new TextEncoder().encode(value);
  const hash = await window.crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(hash)).map((byte) => byte.toString(16).padStart(2, "0")).join("");
};

const hashPin = (restaurantId, pin) => digest(`BillSarthi:${restaurantId}:${pin}`);

export const hasPOSLockPin = (restaurantId) => Boolean(localStorage.getItem(pinKey(restaurantId)));
export const isPOSLocked = (restaurantId) => localStorage.getItem(lockedKey(restaurantId)) === "1";

export const verifyPOSLockPin = async (restaurantId, pin) => {
  const saved = localStorage.getItem(pinKey(restaurantId));
  if (!saved || !/^\d{4,6}$/.test(String(pin || ""))) return false;
  return saved === await hashPin(restaurantId, pin);
};

export const savePOSLockPin = async (restaurantId, pin) => {
  if (!/^\d{4,6}$/.test(String(pin || ""))) throw new Error("PIN must be 4 to 6 digits.");
  localStorage.setItem(pinKey(restaurantId), await hashPin(restaurantId, pin));
  window.dispatchEvent(new CustomEvent(POS_LOCK_EVENT, { detail: { restaurantId } }));
};

export const removePOSLockPin = (restaurantId) => {
  localStorage.removeItem(pinKey(restaurantId));
  localStorage.removeItem(lockedKey(restaurantId));
  window.dispatchEvent(new CustomEvent(POS_LOCK_EVENT, { detail: { restaurantId } }));
};

export const setPOSLocked = (restaurantId, locked) => {
  if (locked && !hasPOSLockPin(restaurantId)) throw new Error("Set a POS Lock PIN in Printer / POS Settings first.");
  localStorage.setItem(lockedKey(restaurantId), locked ? "1" : "0");
  window.dispatchEvent(new CustomEvent(POS_LOCK_EVENT, { detail: { restaurantId, locked } }));
};
